
import orderUtil from '../../Utils/orderUtil.js';

const Css = {
  PaintBoard(w, ml){
    return {
      width: w + "px",
      height: orderUtil.canvasHeight + 'px',
      position: 'relative',
      marginTop: "46px",
      marginLeft: ml + "px"
    }
  },
  dashLine(dashLine, left){
    let obj = {
      width: "1px",
      borderRight: "dashed 1px #999",
      height: "100%",
      display: dashLine?"block":"none",
      position: "absolute",
      left: left + "px",
      top: "0",
    };
    return obj;
  },
  Canvas(mode){
    let obj = {
      width: "100%",
      height: orderUtil.canvasHeight + "px",
    };
    if(mode === 2){
      obj.cursor = "pointer";
    }
    return obj;
  }
}

export default Css;